var _defs, _title, _path, _path2;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLogoMark = function SvgLogoMark(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 716.2,
    height: 697.61,
    viewBox: "0 0 716.2 697.61",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -35.1,
    y1: 647.27,
    x2: 460.89,
    y2: 151.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#76777a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#9e9fa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#bdbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#d4d5d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e1e2e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#dedfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#c7c8ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#a2a4a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 205.43,
    y1: 630.19,
    x2: 768.22,
    y2: 67.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#916914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#a27a27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#c7a250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#deba6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e7c374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#deb15c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8b2a"
  })))), _title || (_title = /*#__PURE__*/React.createElement("title", null, "mark")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M396.46,100.94H250.66c-22.73,0-47.75,17.41-55.66,38.71L2.41,658.9c-7.89,21.29,4.22,38.71,26.91,38.71H175.16c22.69,0,47.74-17.42,55.62-38.71L423.4,139.65c7.88-21.3-4.25-38.71-26.94-38.71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M686.7,0H540.87c-22.69,0-47.65,17.44-55.41,38.78l-225.67,620c-7.76,21.34,4.47,38.81,27.18,38.81H432.79c22.71,0,47.63-17.47,55.4-38.81l225.68-620C721.63,17.44,709.39,0,686.7,0"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoMark, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };